import type { HelpFile } from '../../types/help'
import { ReviewStepTestIds } from '../../../testids/ReviewStepTestIds'

export const reviewStepHelp: HelpFile = {
  docPage: '/docs/onboarding/review',
  texts: {
    [ReviewStepTestIds.cardTitleReviewAttributes]:
      'Im Onboarding erfasste benutzerdefinierte Attribute — vor dem Abschicken auf Korrektheit prüfen.',
    [ReviewStepTestIds.cardTitleReviewIdentity]:
      'Anzulegender Identitätsdatensatz — Login, Typ und Lebenszyklus-Einstellungen.',
    [ReviewStepTestIds.cardTitleReviewOrganization]:
      'Zusammen mit dieser Identität anzulegende Organisation, falls vorhanden.',
    [ReviewStepTestIds.cardTitleReviewPerson]:
      'Personendaten — Name, Kontaktinformationen und persönliche Attribute.',
    [ReviewStepTestIds.reviewDisplayName]:
      'Systemweiter Anzeigename dieser Entität.',
    [ReviewStepTestIds.reviewEditIdentity]:
      'Zum Identitätsschritt zurück, um erfasste Daten zu korrigieren.',
    [ReviewStepTestIds.reviewEditOrganization]:
      'Zum Organisationsschritt zurück, um erfasste Daten zu korrigieren.',
    [ReviewStepTestIds.reviewEditPerson]:
      'Zum Personenschritt zurück, um erfasste Daten zu korrigieren.',
    [ReviewStepTestIds.reviewSectionIdentity]:
      'Im Wizard erfasste Identitätsdaten.',
    [ReviewStepTestIds.reviewSectionOrganization]:
      'Im Wizard erfasste Organisationsdaten.',
  },
}
